import { Link } from "react-router-dom";

const DownloadAPK = () => {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center p-6 text-center gap-6">
            <h1 className="text-4xl font-bold">Download Coreply APK</h1>
            <p className="text-xl">Get the latest version of Coreply for Android</p>

            <a
                href="https://github.com/coreply/coreply/releases/download/2.0.0/coreply-hosted-beta.apk"
                download="coreply-app.apk"
                className="bg-[#18a999] hover:bg-[#16968a] text-white font-semibold py-3 px-8 rounded-lg transition-colors duration-200 inline-block"
            >
                Download APK File Here
            </a>

            <Link to="/" className="text-[#18a999] hover:underline">
                Return to homepage
            </Link>
        </div>
    );
};

export default DownloadAPK;
